import { SVGProps } from 'react'

export const Collapse = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      d="M11 22H9.07129V14.9287H2V13H11V22ZM14.9287 9.07129H22V11H13V2H14.9287V9.07129Z"
      fill="currentColor"
    />
  </svg>
)
